export default __webpack_public_path__ + "static/404-ilustration-0430aeefad41811543b078e180e0d88c.svg";